import React, { ReactElement } from 'react';

import { VideoChatEmbedProps } from 'features/chat';

const YoutubeChat = ({ externalVideoChatProviderIdOrUrl }: VideoChatEmbedProps): ReactElement => (
  <iframe
    title="YoutubeChat"
    src={externalVideoChatProviderIdOrUrl}
    height="100%"
    width="100%"
    frameBorder={0}
  />
);

export default YoutubeChat;
